import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const HeaderContainer = styled.div<{ hideBackButton?: boolean }>`
  display: grid;
  grid-template-columns: 1rem 1fr 1rem;
  gap: 0.5rem;
  width: 100%;
  margin: ${(props) =>
    `${props.hideBackButton ? '0' : '1.5rem'} 0 ${props.hideBackButton ? '0' : '1rem'} 0`};
`

export const Title = styled.h1`
  text-align: center;
  font-size: ${(props) => props.theme.typography.h4.fontSize};
`

export const Description = styled.p`
  text-align: center;
  width: 100%;
  max-width: 20.5rem;
  padding: 0 1rem;
  font-family: ${(props) => props.theme.typography.body1.fontFamily};
  font-weight: ${(props) => props.theme.typography.body1.fontWeight};
  font-size: ${(props) => props.theme.typography.body1.fontSize};
  line-height: ${(props) => props.theme.typography.body1.lineHeight};
  letter-spacing: ${(props) => props.theme.typography.body1.letterSpacing};
  color: ${(props) => props.theme.typography.body1.color};
`

export const BackButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  padding: 0.375rem;
  margin-left: -0.375rem;
  margin-top: -0.375rem;
`
